import React, { useRef, useMemo, useState } from 'react'

import Modal from 'components/common/Modal'
import FormRenderer from 'components/common/FormRenderer'

import useNotification from 'hooks/context/useNotification'

function EditFieldModal({
  open,
  setOpen,
  value,
  fieldData,
  libraryItem,
  updateLibraryItem,
  addLibraryItemNote,
}) {
  const formikRef = useRef()
  const [loading, setLoading] = useState(false)
  const { setBasicNotification, setError } = useNotification()
  const { field: fieldKey, data_type: dataType } = fieldData || {}
  const field = fieldKey || ''
  const libValue = libraryItem?.[field]

  const defaultValue = useMemo(() => {
    if (value) return value

    if (fieldKey === 'note') {
      return libraryItem?._embedded?.notes?.[0]?.note || ''
    }

    return libValue || ''
  }, [libraryItem, value, libValue, dataType, fieldKey])

  const handleSubmit = async (values) => {
    setLoading(true)
    try {
      const updateData = {
        [field]: values[field],
      }

      if (field === 'note') {
        await addLibraryItemNote({
          id: libraryItem?.id,
          note: values[field],
        })
      }

      await updateLibraryItem({
        id: libraryItem?.id,
        updateData,
        isForm: false,
      })

      setBasicNotification('Document has been successfully updated!')
      setOpen(false)
    } catch (err) {
      setError(
        err?.response?.data?.display_message ||
          err?.message ||
          'Error updating document'
      )
    } finally {
      setLoading(false)
    }
  }

  const validate = (values) => {
    const errors = {}

    if (values['note'] !== undefined && !values['note'].trim()) {
      errors[field] = 'Notes must have content'
    }

    return errors
  }

  return (
    <Modal
      hideButtonsBorder
      scrollable={dataType === 'tags'}
      title={`Edit ${fieldData?.display || ''}`}
      width="732px"
      height="auto"
      size={dataType === 'tags' ? 'lg' : undefined}
      open={open}
      footerButtonProps={[
        {
          children: 'Save',
          variant: 'contained',
          color: 'primary',
          size: 'action-header',
          onClick: () => formikRef.current.submitForm(),
          loading: loading,
        },
        {
          children: 'Cancel',
          variant: 'outlined',
          color: 'primary',
          onClick: () => setOpen(false),
          disabled: loading,
        },
      ]}
    >
      <FormRenderer
        renderingData={[{ ...fieldData }]}
        initialData={{
          [field]: defaultValue,
        }}
        innerRef={formikRef}
        handleSubmit={handleSubmit}
        validate={validate}
      />
    </Modal>
  )
}

export default EditFieldModal
